import { jsPDF } from "jspdf";
import { prettyDate } from "./api";

const INK = [44, 40, 37];
const MOSS = [47, 89, 90];
const GOLD = [194, 158, 101];
const INK2 = [92, 86, 77];

export function downloadRecipeBooklet({ guest_name, visit_date, recipes }) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const margin = 56;
  const contentW = pageW - margin * 2;

  // ---- Cover ----
  doc.setFillColor(249, 246, 240);
  doc.rect(0, 0, pageW, pageH, "F");
  doc.setDrawColor(...GOLD);
  doc.setLineWidth(1);
  doc.rect(margin / 2, margin / 2, pageW - margin, pageH - margin);

  doc.setTextColor(...INK2);
  doc.setFont("times", "normal");
  doc.setFontSize(11);
  doc.text("A KEEPSAKE FROM YOUR AFTERNOON", pageW / 2, pageH / 2 - 90, { align: "center" });

  doc.setTextColor(...INK);
  doc.setFont("times", "italic");
  doc.setFontSize(40);
  doc.text("theunfinishedlunch", pageW / 2, pageH / 2 - 40, { align: "center" });

  doc.setDrawColor(...GOLD);
  doc.setLineWidth(1.4);
  doc.line(pageW / 2 - 40, pageH / 2 - 20, pageW / 2 + 40, pageH / 2 - 20);

  doc.setFont("times", "normal");
  doc.setFontSize(16);
  doc.setTextColor(...INK);
  if (guest_name) doc.text(`For ${guest_name}`, pageW / 2, pageH / 2 + 16, { align: "center" });
  doc.setTextColor(...MOSS);
  doc.setFontSize(12);
  if (visit_date) doc.text(`${prettyDate(visit_date)} · Cluj-Napoca`, pageW / 2, pageH / 2 + 38, { align: "center" });

  doc.setTextColor(...INK2);
  doc.setFont("times", "italic");
  doc.setFontSize(12);
  doc.text("The recipes we cooked together — and the secrets that made them ours.", pageW / 2, pageH - margin - 10, {
    align: "center",
    maxWidth: contentW,
  });

  // ---- Recipe pages ----
  (recipes || []).forEach((r) => {
    doc.addPage();
    doc.setFillColor(249, 246, 240);
    doc.rect(0, 0, pageW, pageH, "F");
    let y = margin;

    doc.setTextColor(...GOLD);
    doc.setFont("times", "normal");
    doc.setFontSize(28);
    doc.text(r.number, margin, y);

    doc.setTextColor(...INK);
    doc.setFontSize(26);
    doc.text(r.title, margin + 40, y);
    y += 22;
    doc.setTextColor(...MOSS);
    doc.setFont("times", "italic");
    doc.setFontSize(14);
    doc.text(r.romanian, margin + 40, y);
    y += 26;

    doc.setDrawColor(...GOLD);
    doc.setLineWidth(1);
    doc.line(margin, y, margin + 56, y);
    y += 22;

    doc.setTextColor(...INK2);
    doc.setFont("times", "italic");
    doc.setFontSize(12);
    const blurb = doc.splitTextToSize(r.blurb, contentW);
    doc.text(blurb, margin, y);
    y += blurb.length * 15 + 14;

    const heading = (label) => {
      doc.setTextColor(...INK2);
      doc.setFont("times", "bold");
      doc.setFontSize(10);
      doc.text(label.toUpperCase(), margin, y);
      y += 16;
    };

    heading("What goes in");
    doc.setFont("times", "normal");
    doc.setFontSize(11.5);
    doc.setTextColor(...INK);
    r.ingredients.forEach((ing) => {
      const lines = doc.splitTextToSize(`•  ${ing}`, contentW);
      doc.text(lines, margin, y);
      y += lines.length * 14;
    });
    y += 12;

    heading("How it comes together");
    doc.setFont("times", "normal");
    doc.setFontSize(11.5);
    doc.setTextColor(...INK);
    r.steps.forEach((step, i) => {
      const lines = doc.splitTextToSize(`${i + 1}.  ${step}`, contentW);
      if (y + lines.length * 14 > pageH - margin - 90) {
        doc.addPage();
        doc.setFillColor(249, 246, 240);
        doc.rect(0, 0, pageW, pageH, "F");
        y = margin;
      }
      doc.text(lines, margin, y);
      y += lines.length * 14 + 4;
    });
    y += 14;

    // mystery ingredient callout
    if (y > pageH - margin - 110) {
      doc.addPage();
      doc.setFillColor(249, 246, 240);
      doc.rect(0, 0, pageW, pageH, "F");
      y = margin;
    }
    doc.setFillColor(240, 235, 225);
    const revealLines = doc.splitTextToSize(r.reveal, contentW - 28);
    const boxH = 44 + revealLines.length * 14;
    doc.rect(margin, y, contentW, boxH, "F");
    doc.setFillColor(...GOLD);
    doc.rect(margin, y, 3, boxH, "F");
    doc.setTextColor(...MOSS);
    doc.setFont("times", "italic");
    doc.setFontSize(14);
    doc.text(`The mystery ingredient — ${r.mystery_ingredient}`, margin + 14, y + 22);
    doc.setTextColor(...INK2);
    doc.setFont("times", "normal");
    doc.setFontSize(11);
    doc.text(revealLines, margin + 14, y + 40);
  });

  const safeName = (guest_name || "guest").replace(/\s+/g, "-").toLowerCase();
  doc.save(`theunfinishedlunch-recipes-${safeName}.pdf`);
}
